import { render, staticRenderFns } from "./CuponesAplFormComponent.vue?vue&type=template&id=32daa253&"
import script from "./CuponesAplFormComponent.vue?vue&type=script&lang=js&"
export * from "./CuponesAplFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports